import styled from 'styled-components';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';

export const CtaGrid = styled(Grid)`
  /* normalise spacing at the bottom of the card grid to be spacing(4) */
  padding-top: ${spacing(3)};
  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(2)};
  `}
`;

export const Heading = styled.h3`
  ${fonts.headingMedium}
  text-align: center;

  margin: ${spacing(4)} 0 ${spacing(3)};

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(2)};
  `}
`;
